import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbRelatorioPortaria } from "app/abstract/full-pages/relatorios/relatorio-portaria.abstract";

@Injectable({ providedIn: 'root' })
export class RelatorioPortariaService extends AbRelatorioPortaria {

    constructor(http: HttpClient) {
        super(http);
    }

    getRelatorioPortaria(filter: String): Observable<any> {
        return this.get(`portarias/relatorio/${filter}`);
    }

    getRelatorio(filter: string): Observable<any> {
        return this.get(`portarias/relatorio/gerar/${filter}`);
    }

}